<template>
    <div>
        <a-drawer :title="title" width="1200" :maskClosable="false" closable :visible.sync="show" @close="() => $emit('update:show', false)" :getContainer="() => $parent.$el">
            <a-form-model ref="form" :model="field" :rules="rules" layout="vertical">
                <a-row :gutter="10">
                    <a-col :span="!field.id ? 16 : 24">
                        <a-form-model-item label="机构简称" prop="name">
                            <a-input v-model="field.name" placeholder="请填写机构简称" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="!field.id ? 5 : 0">
                        <a-form-model-item label="绑定码" prop="code" v-if="!field.id">
                            <a-input v-model="field.code" placeholder="请填写管理员绑定码" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="!field.id ? 3 : 0">
                        <a-form-model-item label="有效期（小时）" prop="hour" v-if="!field.id">
                            <a-input-number v-model="field.hour" :min="1" :max="360" suffix="小时" />
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-form-model-item label="标签" prop="tags">
                    <a-input v-model="field.tags" placeholder="请填写标签内容，多个以小写英文逗号区分" />
                </a-form-model-item>
                <a-row :gutter="10">
                    <a-col :span="4">
                        <a-form-model-item label="会员级别" prop="level">
                            <a-select v-model="field.level" placeholder="请选择会员级别">
                                <template v-for="(val, key) in $enums.UserLevel">
                                    <a-select-option :value="key" :key="key">
                                        {{ val }}
                                    </a-select-option>
                                </template>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="10">
                        <a-form-model-item label="机构全称（实名认证）" prop="cname" v-if="field.level != 'Normal'">
                            <a-input v-model="field.cname" placeholder="请填写机构全称" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="6">
                        <a-form-model-item label="信用识别号（实名认证）" prop="csno" v-if="field.level != 'Normal'">
                            <a-input v-model="field.csno" placeholder="请填写机构信用识别号" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="4">
                        <a-form-model-item label="会员到期时间" prop="lvexp" v-if="field.level === 'VIP' || field.level === 'SVIP'">
                            <a-date-picker v-model="field.lvexp" placeholder="请选择到期时间" value-format="YYYY-MM-DD" />
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-form-model-item label="营业地址" prop="addr">
                    <a-input-search v-model="field.addr" placeholder="请选择机构位置" enter-button="选择位置" @search="() => (map = true)" />
                </a-form-model-item>
                <a-row :gutter="10">
                    <a-col :span="16">
                        <a-row :gutter="10">
                            <a-col :span="12">
                                <a-form-model-item label="手机号" prop="mob">
                                    <a-input v-model="field.mob" placeholder="请填写手机号" />
                                </a-form-model-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-model-item label="微信号" prop="wxkey">
                                    <a-input v-model="field.wxkey" placeholder="请填写微信号" />
                                </a-form-model-item>
                            </a-col>
                        </a-row>
                        <a-form-model-item label="邮箱" prop="email">
                            <a-input v-model="field.email" placeholder="请填写邮箱地址" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                        <a-form-model-item label="机构图标" prop="logo">
                            <ImageUpload type="Logo" v-if="show" :img.sync="field.logo"></ImageUpload>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="10">
                    <a-col :span="4">
                        <a-form-model-item label="机构性质" prop="nature">
                            <a-select v-model="field.nature" placeholder="请选择机构性质">
                                <a-select-option value="事业单位">
                                    事业单位
                                </a-select-option>
                                <a-select-option value="卫生单位">
                                    卫生单位
                                </a-select-option>
                                <a-select-option value="社会组织">
                                    社会组织
                                </a-select-option>
                                <a-select-option value="企业">
                                    企业
                                </a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="4">
                        <a-form-model-item label="注册日期" prop="rdate">
                            <a-date-picker v-model="field.rdate" placeholder="请选择注册日期" value-format="YYYY-MM-DD" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="4">
                        <a-form-model-item label="机构法人或负责人" prop="legal">
                            <a-input v-model="field.legal" placeholder="请填写法人或负责人" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="4">
                        <a-form-model-item label="注册资金" prop="rcapt">
                            <a-input v-model="field.rcapt" placeholder="请填写注册资金" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                        <a-form-model-item label="主管单位" prop="manager">
                            <a-input v-model="field.manager" placeholder="请填写主管单位" />
                        </a-form-model-item>
                    </a-col>
                </a-row>

                <a-row :gutter="10">
                    <a-col :span="8">
                        <a-form-model-item label="营业范围" prop="scope">
                            <a-textarea v-model="field.scope" placeholder="请填写营业范围" :auto-size="{ minRows: 2, maxRows: 5 }" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                        <a-form-model-item label="简介摘要" prop="memo">
                            <a-textarea v-model="field.memo" placeholder="请填写简介摘要" :auto-size="{ minRows: 2, maxRows: 5 }" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                        <a-form-model-item label="机构简介" prop="intro">
                            <a-textarea v-model="field.intro" placeholder="请填写机构简介" :auto-size="{ minRows: 2, maxRows: 5 }" />
                        </a-form-model-item>
                    </a-col>
                </a-row>

                <a-row :gutter="10">
                    <a-col :span="12">
                        <a-form-model-item label="影响力" prop="influ">
                            <a-textarea v-model="field.influ" placeholder="请填写机构影响力" :auto-size="{ minRows: 2, maxRows: 5 }" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item label="专业实力" prop="stren">
                            <a-textarea v-model="field.stren" placeholder="请填写专业实力" :auto-size="{ minRows: 2, maxRows: 5 }" />
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-form-model-item label="机构图片" prop="imgs">
                    <ImagesUpload type="UnitImg" v-if="init" :imgs.sync="field.imgs"></ImagesUpload>
                </a-form-model-item>
                <a-form-model-item>
                    <a-button type="primary" @click="doSave" icon="save">
                        保存
                    </a-button>
                    <a-button style="margin-left: 10px;" icon="redo" @click="doReset">
                        重置
                    </a-button>
                </a-form-model-item>
            </a-form-model>
        </a-drawer>

        <MapSelector title="选择地点" :show.sync="map" :locs="locs" v-if="map" @change="setLocs"></MapSelector>
    </div>
</template>

<script>
import MapSelector from '@/comp/MapSelector'
import ImageUpload from '@/comp/ImageUpload'
import ImagesUpload from '@/comp/ImagesUpload'

export default {
    props: {
        show: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        item: {
            type: Object,
            required: false,
            default: () => {
                return {}
            }
        }
    },
    components: {
        MapSelector,
        ImageUpload,
        ImagesUpload
    },
    data() {
        return {
            init: false,
            detail: {},
            map: false,
            locs: {},
            field: {
                id: '',
                code: '',
                hour: 360,
                name: '',
                tags: '',
                cname: '',
                csno: '',
                level: 'Normal',
                lvexp: '',
                logo: '',
                mob: '',
                email: '',
                wxkey: '',
                nature: '事业单位',
                rdate: '',
                area: '',
                addr: '',
                legal: '',
                manager: '',
                rcapt: '',
                scope: '',
                intro: '',
                seal: '',
                influ: '',
                stren: '',
                locs: '',
                memo: '',
                imgs: ''
            },
            rules: {
                name: [{ required: true, message: '请填写机构简称', trigger: 'blur' }],
                level: [{ required: true, message: '请选择会员等级', trigger: 'change' }]
            }
        }
    },
    mounted() {
        if (this.item.id) {
            this.$http
                .get('/ums/unit/info/detail', {
                    params: {
                        id: this.item.id
                    }
                })
                .then(result => {
                    this.detail = result.data
                    Object.keys(this.field).forEach(key => (this.field[key] = this.detail[key] != undefined ? this.detail[key] : this.field[key] || ''))

                    this.field.cname = this.detail.cert.name || ''
                    this.field.csno = this.detail.cert.sno || ''

                    this.locs.locs = this.detail.locs || ''
                    this.locs.code = this.detail.area
                    this.locs.addr = this.detail.addr
                    this.init = true
                })
        } else {
            this.init = true
        }
    },
    methods: {
        setLocs(locs) {
            this.field.locs = locs.locs
            this.field.area = locs.code
            this.field.addr = locs.addr
            this.locs = locs
        },
        doSave() {
            if (!this.field.id) {
                if (!this.field.code) {
                    this.$message.error('请填写绑定码')
                    return
                }
                if (!this.field.hour) {
                    this.$message.error('请填写绑定码有效期')
                    return
                }
            }
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.$http.post('/ums/unit/info/save', this.field).then(result => {
                        if (result.code === 0) {
                            this.$emit('doLoad')
                            this.$emit('update:show', false)
                            this.$message.success('保存成功')
                        }
                    })
                } else {
                    this.$message.error('请填写完整的信息')
                    return false
                }
            })
        },
        doReset() {
            this.$refs.form.resetFields()
            this.$refs.form.clearValidate()
            if (this.item.id) {
                Object.keys(this.field).forEach(key => (this.field[key] = this.detail[key] != undefined ? this.detail[key] : this.field[key] || ''))
            }
        }
    }
}
</script>
